export default __webpack_public_path__ + "static/media/Bengali_am_1.54220b28.mp3";